import {BaseDTO} from "./_baseDTO.interface";
import {AdvertDTO} from "./advertDTO.interface";

export interface ListingDTO extends BaseDTO {
  advert: AdvertDTO;
}
